const machine_txt = {
    type: "VA-0385-D4/AT",
    name: "Long Arm Computer Model Top and Botton Feed Sewing Machine",
    description: [
        "The machine introduction of Germany advanced core technology, independent research and development of the latest varieties, classic lengthened, the needle from the casing column 850mm, a wide range. It adopts link typed feeding mechanism, durability, feed balance, expanded class sewing material and creep in the thick of large sewing materials,make the lower feed speed to reach consensus during sewing. Use the built-in servo motor direct drive, to achieve a quick start and brake the machine accuracy; at the same time using advanced computer control technology, stable performance, strong anti-interference ability, Using big hook, reducing the number of change the bottom line,improve work efficiency; automatic lubricating device to increase machine life. With automatic needle positioning, automatic pin number, automatic cut line, electronic clamp,automatic presser foot, and other intelligent sewing patterns.Suitable for sewing thickmaterial, bags, leather, leather products.",
        "Machine Configuration Description",
        "Actual operating space: 850mm",
        "Available table types: Standard type, Steel bead type, Air flotation type",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/21/machine_img/1.jpg",
        "/assets/machine/21/machine_img/2.jpg",
        "/assets/machine/21/machine_img/3.jpg",
        "/assets/machine/21/machine_img/4.jpg",
    ],
    machine_other_img:[
        "/assets/machine/21/machine_other/1.png",
        "/assets/machine/21/machine_other/2.png",
        "/assets/machine/21/machine_other/3.png",
        "/assets/machine/21/machine_other/4.png",
        "/assets/machine/21/machine_other/5.png",
        "/assets/machine/21/machine_other/6.png",
    ]
}
export default {machine_txt}